import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom';
import { getToken } from '../../../helpers/Jwt';
import axios from 'axios';
import DataTableDynamic from '../../../component/Table/DataTableDynamic';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faClose, faLock, faPhone, faUnlock } from '@fortawesome/free-solid-svg-icons';
import { faClosedCaptioning } from '@fortawesome/free-regular-svg-icons';
import { confirmModal } from '../../../helpers/PromptUtils';

const DashboardKejati = () => {
    const navigate = useNavigate();
    const [keys, setKeys] = useState([]);
    const [columns, setColumns] = useState([]);

    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const BASE_URL = process.env.REACT_APP_API_BASE_URL;
    const PATH_QUEUE = "api/kejati/dashboard/queue";

    const fetchData = async (URL) => {
        setLoading(true);
        try {
            const response = await axios.get(URL, {
                headers: {
                    Authorization: `Bearer ${getToken()}`,
                    "Content-Type": "application/json"
                }
            });
            return response.data; // Return only the data from the response
        } catch (err) {
            setError("Failed to fetch data. Please try again later.");
            console.log(err);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchData(`${BASE_URL}${PATH_QUEUE}?state=priority`).then((data) => {
            setData(data);
        });
    }, []);

    useEffect(() => {
        setKeys(data.length > 0 ? Object.keys(data[0]) : []);
    }, [data]);

    useEffect(() => {
        setColumns(keys.map(key => ({
            Header: key.charAt(0).toUpperCase() + key.slice(1),
            accessor: key
        })));
    }, [keys]);

    const handleClose = async (rowData) => {
        try {
            const confirmed = confirmModal('Yakin Tutup Antrian Tamu ini?');
            if (confirmed) {
                axios({
                    method: 'POST',
                    url: `${BASE_URL}${PATH_QUEUE}/close`,
                    data: {
                        id: rowData.id.value
                    },
                    headers: {
                        Authorization: `Bearer ${getToken()}`,
                        "Content-Type": "application/json"
                    }
                }).then(function (response) {
                    fetchData(`${BASE_URL}${PATH_QUEUE}?state=priority`).then((data) => {
                        setData(data);
                    });
                });
            }
        } catch (error) {
            alert(error)
        }
    }

    const actions = [
    {
        child: <button className='text-white text-xs rounded focus:ring bg-red-500 hover:bg-red-700 p-2 mx-1'>
            <FontAwesomeIcon icon={faLock} color="white" /> Close
        </button>,
        callback: (rowData) => handleClose(rowData)
    }];

    return (
        <div>
            <div className='flex items-center justify-between px-5'>
                <h1>Antrian Menunggu</h1>

                <div className='flex items-center'>                    
                </div>
            </div>

            {loading ? (
                <center><h1>Loading...</h1></center>
            ) : (
                <DataTableDynamic
                    data={data}
                    elementClass="p-1"
                    columns={columns}
                    moduleActions={[]}
                    enableCustom={false}
                    actions={actions} />
            )}
        </div>
    )
}

export default DashboardKejati;
